export const SIGN_UP_PAGE_SIGN_IN_SUGGESTION = 'sign-up-page.sign-in-suggestion';
export const SIGN_UP_PAGE_SIGN_IN_LINK = 'sign-up-page.sign-in-link';
